import { DocumentViewerState } from '@/common/document-viewer/types'
 
export const state: DocumentViewerState = {
  redactDocumentDialogIsOpen: false,
  redactDocumentError: null,
  searchByAIPending: false,
  searchByAIResults: {
    results: {},
    summary: null,
  },
  searchByAIError: null,
}
